import { auth } from './metas'
import RouteDelegate from './RouteDelegate'
const Users = () => import('@/pages/Users')
const User = () => import('@/pages/User')

export default [
  {
    path: '/users',
    component: RouteDelegate,
    meta: auth,
    children: [
      {
        path: '',
        name: 'Users',
        component: Users,
        meta: auth,
        props: route => ({
          page: (parseInt(route.query.page, 10) || 1),
          descending: route.query.descending === 'true',
          sortBy: route.query.sortBy
        })
      },
      {
        path: ':id/:tab',
        name: 'User',
        component: User,
        meta: auth,
        props: route => ({
          id: parseInt(route.params.id, 10),
          tab: route.params.tab || 'profile'
        })
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/users.route.js